export const mutations = {
    SET_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    SET_USERDATA(state, userData) {
        state.userData = { ...state.userData, ...userData };
    },
    SET_HAS_ANY_API_LICENSE(state, data) {
        state.hasAnyApiLicense = data;
    },
    SET_USER_IS_BRK_AUTHORIZED(state, data) {
        state.userIsBrkAuthorized = data;
    },
    SET_USER_IS_NEDBRK_AUTHORIZED(state, data) {
        state.userIsNedBrkAuthorized = data;
    },
    SET_USER_IS_BRP_AUTHORIZED(state, data) {
        state.userIsBrpAuthorized = data;
    },
    SET_USER_IS_WOZ_AUTHORIZED(state, data) {
        state.userIsWozAuthorized = data;
    },
    SET_USER_IS_STUF_AUTHORIZED(state, data) {
        state.userIsStufAuthorized = data;
    },
    SET_USER_IS_ALLOWED_STUF_PERSON_QUERIES(state, data) {
        state.userIsAllowedStufPersonQueries = data;
    },
    SET_USER_IS_KVK_AUTHORIZED(state, data) {
        state.userIsKvkAuthorized = data;
    },
    SET_USER_IS_ENERGYLABEL_AUTHORIZED(state, data) {
        state.userIsEnergyLabelAuthorized = data;
    },
    SET_USER_WOZ_API_ID(state, apiId) {
        state.userWozApiId = apiId;
    },
    SET_USER_WOZ_API_DATA(state, data) {
        state.userWozApiData = data;
    }
};
